var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOdometer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45 11.5C8.86667 11.9167 9.39167 12.1127 10.025 12.088C10.6583 12.0633 11.1167 11.834 11.4 11.4L17 3L8.6 8.6C8.16667 8.9 7.92933 9.354 7.888 9.962C7.84667 10.57 8.034 11.0827 8.45 11.5ZM3.1 16C2.73333 16 2.396 15.9207 2.088 15.762C1.78 15.6033 1.534 15.366 1.35 15.05C0.916667 14.2667 0.583333 13.4543 0.35 12.613C0.116667 11.7717 0 10.9007 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.82433 2.025 4.88267 1.31267 6.1 0.788C7.31733 0.263333 8.61733 0.000666667 10 0C11.3667 0 12.65 0.258333 13.85 0.775C15.05 1.29167 16.1 1.996 17 2.888C17.9 3.78 18.6167 4.82167 19.15 6.013C19.6833 7.20433 19.9583 8.48333 19.975 9.85C19.9917 10.7667 19.8877 11.6627 19.663 12.538C19.4383 13.4133 19.0923 14.2507 18.625 15.05C18.4417 15.3667 18.196 15.6043 17.888 15.763C17.58 15.9217 17.242 16.0007 16.874 16H3.1Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOdometer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/odometer.e767f057b3981c63b3b52df270060277.svg";